let moment = require('moment');


export let colLegalEntityName = {
                                    colId: 'legalEntityName',
                                    headerName: 'Name',
                                    field: 'legalEntityName',
                                    width: 100,
                                    sortable: true
                                };

export let colAddress = {
                                colId: 'address',
                                headerName: 'Address',
                                field: 'address',
                                width: 100,
                                sortable: true
                            };

export let colCity = {
                                colId: 'city',
                                headerName: 'City',
                                field: 'city',
                                width: 100,
                                sortable: true
                            };

export let colComments = {
                                colId: 'comments',
                                headerName: 'Comments',
                                field: 'comments',
                                width: 100,
                                sortable: true
                            };

export let colState = {
                                colId: 'state',
                                headerName: 'State',
                                field: 'state',
                                width: 100,
                                sortable: true
                            };

export let colZip = {
                                colId: 'zip',
                                headerName: 'Zip Code',
                                field: 'zip',
                                width: 100,
                                sortable: true
                            };


export let colFein = {
                                colId: 'fein',
                                headerName: 'Legal Entity FEIN',
                                field: 'fein',
                                width: 100,
                                sortable: true
                            };


export let allColumns = [

    colLegalEntityName,
    colAddress,
    colCity,
    colComments,
    colState,
    colZip,
    colFein
];




export let columnSelectList = [
    {
        value: colLegalEntityName,
        viewValue: colLegalEntityName.headerName
    },
    {
        value: colAddress,
        viewValue: colAddress.headerName
    },
    {
        value: colCity,
        viewValue: colCity.headerName
    },
    {
        value: colComments,
        viewValue: colComments.headerName
    },
    {
        value: colState,
        viewValue: colState.headerName
    },
    {
        value: colZip,
        viewValue: colZip.headerName
    },
    {
        value: colFein,
        viewValue: colFein.headerName
    }
];


